// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__319rC","title":"FrontImage_title__1r_HO"};